import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { 
  IcSettings, IcStatusSuccessful, IcLayout, IcBusinessman, IcHome,
  IcDatabase, IcTime, IcPerson, IcDocument, IcNetwork, IcCookies, 
  IcNotes, IcForms, IcNotification, IcBuilding, IcGroup, IcMail, 
  IcCalendar, IcTrash, IcTicketDetails
} from "../custom-components/Icon";
import { Icon } from "../custom-components";
import "../styles/topNav.css";

const consentColumn = {
  title: "Consent",
  icon: <IcStatusSuccessful height={18} width={18} />,
  theme: "green",
  items: [
    { label: "Consent Templates", path: "/templates", icon: <IcDocument height={16} width={16} /> },
    { label: "Consent Configuration", path: "/consent", icon: <IcSettings height={16} width={16} /> },
  ]
};

const cookiesColumn = {
  title: "Cookies",
  icon: <IcCookies height={18} width={18} />,
  theme: "green",
  items: [
    { label: "Cookie Templates", path: "/registercookies", icon: <IcCookies height={16} width={16} /> },
    { label: "Cookie Categories", path: "/cookie-category", icon: <IcLayout height={16} width={16} /> },
  ]
};

const rightsManagementColumn = {
  title: "Rights Management (DSAR)",
  icon: <IcPerson height={18} width={18} />,
  theme: "blue",
  items: [
    { label: "User Portal Branding", path: "/user-dashboard", icon: <IcLayout height={16} width={16} /> },
    { label: "Grievance Templates", path: "/grievanceFormTemplates", icon: <IcNotes height={16} width={16} /> },
    { label: "Grievance Configuration", path: "/grievance", icon: <IcSettings height={16} width={16} /> },
    { label: "Notification Templates", path: "/notification-templates", icon: <IcMail height={16} width={16} /> },
    { label: "Notification Configuration", path: "/notification", icon: <IcNotification height={16} width={16} /> },
  ]
};

const governanceCol1 = {
  title: "Governance",
  icon: <IcDocument height={18} width={18} />,
  theme: "purple",
  items: [
    { label: "DPO Dashboard", path: "/dpo-dashboard", icon: <IcHome height={16} width={16} /> },
    { label: "Record of Processing Activities (ROPA)", path: "/ropa", icon: <IcForms height={16} width={16} /> },
    { label: "Cookie Register", path: "/cookieslogs", icon: <IcNotes height={16} width={16} /> },
    { label: "Consent Register", path: "/consent-datasets", icon: <IcDocument height={16} width={16} /> },
    { label: "Consent Logs", path: "/consentLogs", icon: <IcTicketDetails height={16} width={16} /> }
  ]
};

const governanceCol2 = {
  title: "Grievances",
  icon: <IcNotes height={18} width={18} />,
  theme: "purple",
  items: [
    { label: "Grievance Register", path: "/request", icon: <IcDocument height={16} width={16} /> },
  ]
};

const governanceCol3 = {
  title: "Breach Management",
  icon: <IcTicketDetails height={18} width={18} />,
  theme: "purple",
  items: [
    { label: "Breach Notification", path: "/breach-notifications", icon: <IcTicketDetails height={16} width={16} /> },
    { label: "DPB Digital Office Notification (upcoming)", path: "/dpb-digital-office-sync", icon: <IcNetwork height={16} width={16} /> }
  ]
};

const reportsColumn = {
  title: "Reports",
  icon: <IcDocument height={18} width={18} />,
  theme: "orange",
  items: [
    { label: "Audit and Compliance Reports", path: "/audit-compliance", icon: <IcStatusSuccessful height={16} width={16} /> },
    { label: "Consent Callbacks and Data Deletion Report", path: "/data-compliance-report", icon: <IcDocument height={16} width={16} /> },
    { label: "Data deletion and purge dashboard", path: "/data-deletion-purge-dashboard", icon: <IcTrash height={16} width={16} /> },
    { label: "Scheduler Statistics", path: "/scheduler-stats", icon: <IcCalendar height={16} width={16} /> }
  ]
};

const settingsCol1 = {
  title: "Platform Configuration",
  icon: <IcSettings height={18} width={18} />,
  theme: "blue",
  items: [
    { label: "Master Data (PII data types, items)", path: "/master?tab=PII", icon: <IcDatabase height={16} width={16} /> },
    { label: "Data Processors", path: "/master?tab=DataProcessor", icon: <IcNetwork height={16} width={16} /> },
    { label: "Processing Activities", path: "/master?tab=ProcessingActivity", icon: <IcTime height={16} width={16} /> },
    { label: "Processing Purposes", path: "/master?tab=Purpose", icon: <IcDocument height={16} width={16} /> },
    { label: "Data Retention", path: "/retention-policies", icon: <IcTime height={16} width={16} /> }
  ]
};

const settingsCol2 = {
  title: "Organization Setup",
  icon: <IcBusinessman height={18} width={18} />,
  theme: "blue",
  items: [
    { label: "Business Units", path: "/business", icon: <IcBuilding height={16} width={16} /> },
    { label: "Business Hierarchy", path: "/organization-map", icon: <IcNetwork height={16} width={16} /> },
    { label: "Users & Teams", path: "/users", icon: <IcGroup height={16} width={16} /> },
    { label: "Roles & Permissions", path: "/roles", icon: <IcSettings height={16} width={16} /> },
    { label: "Data Protection Officer (DPO)", path: "/dataProtectionOfficer", icon: <IcBusinessman height={16} width={16} /> }
  ]
};

const navData = [
  {
    title: "Privacy Management",
    icon: <IcDocument height={18} width={18} />,
    theme: "green",
    columns: [consentColumn, cookiesColumn, rightsManagementColumn]
  },
  {
    title: "Governance",
    icon: <IcStatusSuccessful height={18} width={18} />,
    theme: "purple",
    columns: [governanceCol1, governanceCol2, governanceCol3]
  },
  {
    title: "Reports",
    icon: <IcDocument height={18} width={18} />,
    theme: "orange",
    columns: [reportsColumn]
  },
  {
    title: "Settings",
    icon: <IcSettings height={18} width={18} />,
    theme: "blue",
    columns: [settingsCol1, settingsCol2]
  }
];

const TopNav = () => {
  const [activeMenu, setActiveMenu] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();
  const navRef = React.useRef(null);

  React.useEffect(() => {
    const handleClickOutside = (event) => {
      if (navRef.current && !navRef.current.contains(event.target)) {
        setActiveMenu(null);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleNavigation = (path) => {
    navigate(path);
    setActiveMenu(null);
  };

  const toggleMenu = (index) => {
    if (activeMenu === index) {
      setActiveMenu(null);
    } else {
      setActiveMenu(index);
    }
  };

  const getTourId = (title) => {
    switch(title) {
      case 'Configuration': return 'menu-configuration';
      case 'Consent Management': return 'menu-consent-management';
      case 'Compliance': return 'menu-compliance';
      case 'Administration': return 'menu-administration';
      default: return '';
    }
  };

  return (
    <div className="topnav-container" ref={navRef} data-tour="top-menu">
      <div 
        className={`topnav-item ${location.pathname === '/dpo-dashboard' ? 'active' : ''}`}
        onClick={() => handleNavigation('/dpo-dashboard')}
      >
        <div className="topnav-header">
          <span className="topnav-icon">
            <Icon kind="default" ic={<IcHome height={18} width={18} />} color={location.pathname === '/dpo-dashboard' ? "primary-blue-100" : "primary-grey-80"} />
          </span>
          <span className="topnav-title">Dashboard</span>
        </div>
      </div>

      {navData.map((menu, index) => {
        // Check if any sub-item in any column is active
        const isActive = menu.columns.some(col => col.items.some(item => {
          if (item.path.includes('?')) {
            return location.pathname + location.search === item.path || (location.pathname === item.path.split('?')[0] && !location.search && item.path.includes('tab=PII'));
          }
          return location.pathname === item.path;
        }));
        
        return (
          <div 
            key={index} 
            data-tour={getTourId(menu.title)}
            className={`topnav-item ${activeMenu === index ? 'hovered' : ''} ${isActive ? 'active' : ''} theme-${menu.theme}`}
            onClick={() => toggleMenu(index)}
          >
            <div className="topnav-header">
              <span className="topnav-icon">
                {React.cloneElement(menu.icon, { color: (activeMenu === index || isActive) ? 'currentColor' : '#475569' })}
              </span>
              <span className="topnav-title">{menu.title}</span>
              <span className="topnav-chevron">
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  {activeMenu === index ? <polyline points="18 15 12 9 6 15"></polyline> : <polyline points="6 9 12 15 18 9"></polyline>}
                </svg>
              </span>
            </div>

            {/* Dropdown Menu - rendered inside the relative parent */}
            {activeMenu === index && (
              <div 
                className="mega-menu" 
                onClick={(e) => e.stopPropagation()}
                style={
                  index === 0 ? { left: 0 } :
                  index === navData.length - 1 ? { left: 'auto', right: 0 } :
                  { left: '50%', transform: 'translateX(-50%)' }
                }
              >
                {menu.columns.map((col, idx) => (
                  <div key={idx} className="mega-menu-column">
                    {menu.columns.length > 1 && (
                      <div className={`mega-menu-column-header header-theme-${col.theme}`}>
                        <span className="mega-menu-icon">
                          {React.cloneElement(col.icon, { color: 'currentColor' })}
                        </span>
                        <span>{col.title}</span>
                      </div>
                    )}
                    <ul className="mega-menu-list">
                      {col.items.map((item, itemIdx) => {
                        const isItemActive = (() => {
                          if (item.path.includes('?')) {
                            return location.pathname + location.search === item.path || (location.pathname === item.path.split('?')[0] && !location.search && item.path.includes('tab=PII'));
                          }
                          return location.pathname === item.path;
                        })();
                        return (
                          <li 
                            key={itemIdx} 
                            className={isItemActive ? 'active' : ''}
                            onClick={() => handleNavigation(item.path)}
                          >
                            <span className="mega-item-icon">
                              {React.cloneElement(item.icon, { color: isItemActive ? '#2563EB' : '#64748B' })}
                            </span>
                            {item.label}
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                ))}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default TopNav;
